// /*
//   USER ACTIONS
//  */
// export const USER__LOGIN = 'USER__LOGIN';
// export const USER__LOGOUT = 'USER__LOGOUT';
//
// export function userLogin(user) {
//   return {
//     type: USER__LOGIN,
//     user,
//   };
// }
//
// export function userLogout() {
//   return {
//     type: USER__LOGOUT,
//   };
// }
//
// /*
//   BLUEPRINT ACTIONS
//  */
// export const BLUEPRINT__SAVE_FOR_SUBMISSION = 'BLUEPRINT__SAVE_FOR_SUBMISSION';
//
// export function saveBlueprintForSubmission(data) {
//   return {
//     type: BLUEPRINT__SAVE_FOR_SUBMISSION,
//     data,
//   };
// }

import * as blueprints from './blueprints';
import * as discussions from './discussions';
import * as users from './users';
import * as groups from './groups';
import * as faqs from './faqs';

export default {
  blueprints,
  discussions,
  users,
  groups,
  faqs
};


// WEBPACK FOOTER //
// ./src/store/actions/index.js